export default __webpack_public_path__ + "static/media/Drain.56d81e96.jpg";